<template>
  <div class="normal-sidebar" @click="$emit('click')">
    <div class="normal-sidebar__group-menu--wrapper">
      <div class="normal-sidebar__header-space" />
      <div
        v-for="(group, groupIndex) in sidebarGroupItems"
        :key="group.key"
        class="normal-sidebar__group-menu"
      >
        <div v-if="group.divider && groupIndex > 0" class="divider-wrapper">
          <div class="divider" />
        </div>

        <div v-if="group.title" class="normal-sidebar__group-menu__header">
          {{ group.title }}
        </div>
        <SidebarItem
          v-for="route in group.routes"
          :key="route.path"
          :is-collapsed="isCollapsed"
          :item="route"
          :base-path="route.path"
          :is-kyc-user="isKycUser"
          @click:arrow="handleClickArrow"
        />
      </div>
    </div>
  </div>
</template>

<script>
const MENU_ITEMS_CONFIG = [
  {
    key: 'default',
    title: '',
    divider: false,
    routes: ['/dashboard', '/orders', '/dispute', '/ads', '/farah'],
  },
  {
    key: 'payment',
    title: 'sidebar_group_title_payments',
    divider: true,
    routes: ['/settlement', '/transaction'],
  },
  {
    key: 'setting',
    title: 'sidebar_group_title_settings',
    divider: true,
    routes: [
      '/address-collection',
      '/exports',
      '/contact-details',
      '/webhooks',
      '/settings',
      '/api',
      '/users',
    ],
  },
]

const _getRouteByBasePath = (sourceRoutes, basePath) =>
  sourceRoutes.find((route) => route.path === basePath)

export default {
  name: 'SidebarNormal',
  props: {
    subMerchantAccounts: {
      type: Array,
      default: () => [],
    },
    showSubMerchantAccounts: {
      type: Boolean,
      default: false,
    },
    merchantProfile: {
      type: Object,
      default: () => ({}),
    },
    subMerchants: {
      type: Array,
      default: () => [],
    },
    isCollapsed: {
      type: Boolean,
      default: false,
    },
    permissionRoutes: {
      type: Array,
      default: () => [],
    },
    isKycUser: {
      type: Boolean,
      default: false,
    },
    activeSubMerchantName: {
      type: String,
      default: '',
    },
  },
  computed: {
    sidebarGroupItems() {
      return MENU_ITEMS_CONFIG.map((menuGroup) => ({
        key: menuGroup.key,
        divider: menuGroup.divider,
        title: this.$te(menuGroup.title)
          ? this.$t(menuGroup.title)
          : menuGroup.title,
        routes: this.mapMenuGroupWithRoutes(menuGroup.routes),
      })).filter((group) => group.routes.length > 0)
    },
  },
  methods: {
    mapMenuGroupWithRoutes(routes) {
      return routes
        .map((menuPath) => _getRouteByBasePath(this.permissionRoutes, menuPath))
        .filter((route) => !!route)
    },
    handleClickArrow(subMenuRef, path) {
      this.$emit('click:arrow', subMenuRef, path)
    },
  },
}
</script>

<style lang="scss" scoped>
.normal-sidebar {
  width: 100%;

  &__header-space {
    height: 18px;
  }

  &__group-menu {
    &__header {
      height: 32px;
      padding-inline: 24px;
      font-family: 'Helvetica Neue', sans-serif;
      font-size: 11px;
      font-weight: 500;
      line-height: 20px;
      color: #999;
      text-align: start;
    }
  }
}
</style>
